import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'company-staffs', // 资源路径
    defaultRels: ['company'], // 默认需要的关联数据
  }

})
